import { Flex, type FlexProps } from "@repo/ui/core";
import type { FC, PropsWithChildren } from "react";

export const ContentColumn: FC<
  PropsWithChildren<
    Omit<FlexProps, "direction" | "h"> & {
      // additional props if needed...
    }
  >
> = ({ children, ...props }) => {
  return (
    <Flex
      direction="column"
      h="calc(100dvh - var(--app-shell-header-offset, 0rem) - var(--app-shell-footer-offset, 0rem) - 2 * var(--app-shell-padding))"
      {...props}
    >
      {children}
    </Flex>
  );
};
